export default {
	sec_10: {
		title: {
			one: '入金 ',
			two: '受け取り',
		},
		desc: {
			one: 'JP WORLD PAYで便利に入金を受け取ってください。',
		},
		btn: {
			one: '資産を送る',
			two: 'アプリダウンロード',
		},
	},
	sec_11: {
		title: {
			one: '最も便利な送金',
		},
		desc: {
			one: '相手のEメールに送信して完了',
		},
	},
	sec_04: {
		title: '受領者側に表示されること',
		cards: {
			one: {
				title: {
					one: 'JP WORLD PAYと',
					two: 'JP WORLD PAY間の送金',
				},
				description: {
					one: 'JP WORLD PAYから',
					two: 'JP WORLD PAYへ送金時',
					three: '使用される口座番号が露出されます。',
				},
			},
			two: {
				title: {
					one: '外部から',
					two: 'JP WORLD PAYに入金',
				},
				description: {
					one: '外部からJP WORLD PAYに入金時',
					two: '使用されるウォレット',
					three: '住所が露出されます。',
				},
			},
		},
	},
};
